import { Box, Flex, Stack, Text } from '@chakra-ui/react'
import dayjs from 'dayjs'

import { PatientInfo } from '../../types'

type Props = {
  patient: PatientInfo
}

export const PrintPatientInfo: React.FC<Props> = ({ patient }) => {
  const fullName =
    patient.lastName && patient.firstName
      ? `${patient.lastName} ${patient.firstName}`
      : undefined

  const formattedBirthday = patient.birthday
    ? dayjs(patient.birthday).format('YYYY年MM月DD日')
    : undefined

  return (
    <Box mb="6" className="print-patient-info">
      <Stack spacing="1">
        <Flex>
          <Text fontWeight="bold">症例番号：</Text>
          <Text>{patient.diseaseUid}</Text>
        </Flex>
        {fullName && (
          <Flex>
            <Text fontWeight="bold">患者氏名：</Text>
            <Text>{fullName}</Text>
          </Flex>
        )}
        {formattedBirthday && (
          <Flex>
            <Text fontWeight="bold">生年月日：</Text>
            <Text>{formattedBirthday}</Text>
          </Flex>
        )}
      </Stack>
    </Box>
  )
}
